import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLower = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 200 200",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M186.1,103.3c-1,5.9-4.9,9.9-8.7,14c-20.4,22.2-40.6,44.6-60.9,66.7c-1.6,1.8-3.1,3.6-4.8,5.1 c-7.3,6.5-18,5.8-24.8-1.5c-5.7-6.3-11.4-12.4-17.1-18.8c-17-18.6-33.8-37-50.7-55.6c-6.9-7.5-6.9-17.8,0.1-24.9 c3.1-3.2,7.1-4.8,11.6-5c4.8-0.2,24.6,0,29.4,0c0.5,0,1,0,1.6,0c0-0.8,0-1.5,0-2.1c0-13.2,0-41.5,0-54.8 c0-8.4,5.7-15.4,13.8-17.4c0.9-0.3,2-0.3,3-0.6c24.1,0,18.5,0,42.6,0c1,0.1,2,0.3,3,0.6c8.2,1.9,13.8,8.9,13.8,17.2 c0,13.4,0,41.7,0,54.9c0,0.6,0,1.4,0,2.1c5.6,0,25.8-0.2,31.1,0c5.5,0.1,9.9,2.5,13.3,6.9c1.9,2.4,2.7,5.2,3.6,8.2 C186.1,100.1,186.1,101.8,186.1,103.3z M100.1,21.8c-11.5,0-8,0-19.5,0c-3.9,0-5.5,1.8-5.5,5.7c0,16.2,0,47.4,0,63.6 c0,3.8-1.8,5.5-5.5,5.5c-7.5,0-30,0-37.5,0c-2.1,0-3.6,0.8-4.5,2.7s-0.3,3.6,1.1,5.1c1.5,1.7,3.1,3.5,4.6,5.1 c21,23.1,42.2,46.2,63.1,69.3c2.4,2.6,5,2.6,7.3,0c22.5-24.8,45-49.3,67.7-74.1c1.5-1.5,2.2-3.3,1.2-5.4c-0.9-2-2.5-2.5-4.7-2.5 c-7.3,0-29.5-0.2-36.9,0c-3.3,0-6.1-1.7-6-6c0.2-16,0-47.1,0-63c0-4.1-1.6-5.7-5.8-5.7C107.9,21.8,111.5,21.8,100.1,21.8z",
			fill: "currentColor"
		}) }) }) }),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {})
	]
});
export { SvgIconLower as ReactComponent };
